import { PathOptions } from "leaflet";

export const canais = (feature: any): PathOptions => {
    return {
      color: "#897044",
      weight: 1,
      opacity: 1,
    };
  };
